module.exports = __webpack_public_path__ + "img/close-icn.76c27348.svg";